import React, { useContext } from 'react'
import { View } from 'oio-react'
import uiConstants from 'config/constants/ui'
import { useMe } from 'src/graphql/hooks'
import ThemeContext from 'src/libraries/contexts/Theme'
import IconDrawerMenuButton from '../IconDrawerMenuButton'
import IconMessageButton from '../IconMessageButton'
import IconSearchButton from '../IconSearchButton'
import Logo from '../Logo'
import PageNav from '../PageNav'
import UserAccountControl from '../UserAccountControl'

const GlobalNavLayoutHorizontal = () => {
   const theme = useContext(ThemeContext)
   const { isLoggedIn, loading } = useMe()

   return (
      <View
         position="absolute"
         display={theme.globalNavIsHidden ? 'none' : 'flex'}
         justifyContent="center"
         flexFlow="row"
         top="0px"
         left="0px"
         right="0px"
         height={theme.globalNavSize}
         paddingLeft={theme.viewportMarginLeft}
         paddingRight={theme.viewportMarginRight}
         backgroundColor={theme.globalNavBackgroundColor}
         borderBottom={`1px solid ${theme.globalNavBorderColor}`}
         zIndex={uiConstants.zIndexes.globalNav}>
         <View
            display="flex"
            width="100%"
            maxWidth={theme.viewportContentMaxWidth}
            height="100%"
            flexFlow="row"
            justifyContent="space-between[a-c] center[d-f]"
            alignItems="center"
            paddingLeft={theme.viewportPaddingLeft}
            paddingRight={theme.viewportPaddingRight}>
            <View
               display="flex"
               flex="0 0 auto"
               justifyContent="flex-start"
               alignItems="center"
               height="48px">
               <Logo />
               <View width="36px[c-f]" height="36px" />
            </View>
            <View
               display="flex"
               flex="1 1 auto"
               justifyContent="flex-start"
               alignItems="center"
               height="48px">
               <PageNav
                  display="none[a-c] flex[d-f]"
                  flex="1 1 auto"
               />
            </View>
            <View
               display="flex"
               flex="0 0 auto"
               justifyContent="flex-end"
               alignItems="center"
               height="48px">
               {!loading && <UserAccountControl nameFormat="fullName" />}
               <View
                  display="none[a-c] flex[d-f]"
                  justifyContent="center"
                  alignItems="center"
                  flex="0 0 auto"
                  width="48px"
                  height="48px">
                  <View
                     width="1px"
                     height="24px"
                     backgroundColor={theme.globalNavDividerColor}
                  />
               </View>
               <View display="flex" alignItems="center" width="60px[a-c]">
                  <IconSearchButton size="20px" />
                  <View
                     display="block[a-c] block[d-f]"
                     width="20px[a-c] 25px[d-f]"
                     height="48px"
                  />
                  {isLoggedIn && (
                     <IconMessageButton
                        display="none[a-c] block[d-f]"
                        size="18px"
                     />
                  )}
                  <IconDrawerMenuButton display="flex[a-c] none[d-f]" />
               </View>
            </View>
         </View>
      </View>
   )
}

export default GlobalNavLayoutHorizontal
